<template>
  <div style="background-color:#fff;padding:10px 20px">
    <!-- 查询表单 -->
    <div style="margin-bottom:10px">
       <el-row style="margin-top:10px">
          <el-col :span="6">物品编码：{{itemDetailData.itemCode}}</el-col>
          <el-col :span="6">订单编码：{{itemDetailData.orderCode}}</el-col>
           <el-col :span="6">状态：
              <span v-if="itemDetailData.status === 0">待质检</span>
              <span v-else-if="itemDetailData.status === 1">待确认</span>
              <span v-else-if="itemDetailData.status === 2">待结算</span>
              <span v-else-if="itemDetailData.status === 3">已结算</span>
              <span v-else-if="itemDetailData.status === 4">待议价</span>
              <span v-else-if="itemDetailData.status === 5">待退货</span>
              <span v-else-if="itemDetailData.status === 6">退货中</span>
              <span v-else-if="itemDetailData.status === 7">已退货</span>
            </el-col>
       </el-row>
       <el-row  style="margin-top:10px">
          <el-col :span="6">分类：{{itemDetailData.categoryName}}</el-col>
          <el-col :span="6">品牌：{{itemDetailData.brandName}}</el-col>
          <el-col :span="6">机型：{{itemDetailData.modelName}}</el-col>
          <el-col :span="6">回收商：{{itemDetailData.recyclerName}}</el-col>
       </el-row>
         <el-row  style="margin-top:10px">
          <el-col :span="6">等级：{{itemDetailData.gradeName}}</el-col>
          <el-col :span="6">回收价：{{itemDetailData.recoveryAmount}}元</el-col>
          <el-col :span="6">加价金额：{{itemDetailData.markUpAmount}}元</el-col>
       </el-row>
        <el-row  style="margin-top:10px">
          <el-col :span="6">收货时间：{{itemDetailData.receiveTime}}</el-col>
          <el-col :span="6">收货人：{{itemDetailData.receiverName}}({{itemDetailData.receiverPhone}})</el-col>
       </el-row>
        <el-row  style="margin-top:10px" v-if="itemDetailData.qualityTime!=null">
          <el-col :span="6">质检时间：{{itemDetailData.qualityTime}}</el-col>
          <el-col :span="6">质检金额：{{itemDetailData.qualityAmount}}</el-col>
          <el-col :span="6">质检人：{{itemDetailData.qualityerName}}({{itemDetailData.qualityerPhone}})</el-col>
       </el-row>
         <el-row  style="margin-top:10px" v-if="itemDetailData.bargainingTime!=null">
          <el-col :span="6">议价时间：{{itemDetailData.bargainingTime}}</el-col>
          <el-col :span="6">加价金额：{{itemDetailData.markUpAmount}}</el-col>
          <el-col :span="6">议价人：{{itemDetailData.chaffererName}}({{itemDetailData.chaffererPhone}})</el-col>
           <el-col :span="6">议价记录：{{itemDetailData.chafferCode}}</el-col>
       </el-row>
         <el-row  style="margin-top:10px" v-if="itemDetailData.settlementTime!=null">
          <el-col :span="6">结算时间：{{itemDetailData.settlementTime}}</el-col>
          <el-col :span="6">结算金额：{{itemDetailData.recoveryAmount}}</el-col>
          <el-col :span="6">结算人：{{itemDetailData.settlementName}}({{itemDetailData.settlementPhone}})</el-col>
          <el-col :span="6">结算记录：{{itemDetailData.settlementCode}}</el-col>
       </el-row>
    </div>
    <div style="margin:30px 0">质检报告</div>
    <div style="margin-top:20px">
       <el-row>
            <el-col :span="6">品牌：{{itemDetailData.brandName}}</el-col>
            <el-col :span="6">型号：{{itemDetailData.modelName}}</el-col>
          </el-row >
          <el-row style="margin-top:10px">
             <el-col :span="6">内存：{{itemDetailData.memory}}</el-col>
            <el-col :span="6">IMEI：{{itemDetailData.imei}}</el-col>
          </el-row >
            <el-row style="margin-top:10px">
            <el-col :span="6">机器概况：{{itemDetailData.machineOverview}}</el-col>
            <el-col :span="6">购买渠道：{{itemDetailData.purchaseChannel}}</el-col>
          </el-row>
           <el-row style="margin-top:10px">
             <el-col :span="6">网络制式：{{itemDetailData.networkSystem}}</el-col>
            <el-col :span="6">屏幕外观：{{itemDetailData.screenAppearance}}</el-col>
          </el-row>
           <el-row style="margin-top:10px">
            <el-col :span="6">外观项：{{itemDetailData.appearanceItem}}</el-col>
            <el-col :span="6">显示项：{{itemDetailData.displayItem}}</el-col>
          </el-row>
          <el-row style="margin-top:10px">
             <el-col :span="6">屏幕维修项：{{itemDetailData.screenMaintenanceItem}}</el-col>
            <el-col :span="6">相机维修项：{{itemDetailData.cameraMaintenanceItem}}</el-col>
          </el-row>
          <el-row style="margin-top:10px">
            <el-col :span="6">后壳维修项：{{itemDetailData.backCoverMaintenanceItem}}</el-col>
            <el-col :span="6">功能项：{{itemDetailData.functionItem}}</el-col>
          </el-row>
          <el-row style="margin-top:10px">
             <el-col :span="6">维修项：{{itemDetailData.maintenanceItem}}</el-col>
            <el-col :span="6">ID：{{itemDetailData.machineId}}</el-col>
          </el-row>
           <el-row style="margin-top:10px">
            <el-col :span="6">等级：{{itemDetailData.gradeName}}</el-col>
            <el-col :span="6">颜色：{{itemDetailData.color}}</el-col>
          </el-row>
          <el-row style="margin-top:10px">
             <el-col :span="6">质检价：{{itemDetailData.recoveryAmount}}元</el-col>
             <el-col :span="6">备注问题：{{itemDetailData.remark}}</el-col>
          </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name:"itemDetail",
  components: {},
  props: {},
  data() {
    return {
      itemDetailData:{},
    };
  },
  watch: {
    itemCode:"getItemInfo"
  },
  computed: {},
  methods: {
    init(itemCode){
      this.getItemInfo(itemCode)
    },
    getItemInfo(itemCode){
        this.itemDetailData={}
        let self = this
        this.$api.getItemInfo({itemCode:itemCode}).then((res)=>{
              self.itemDetailData =res.data
        })
      }
    },
  created() {},
  mounted() {
  },
};
</script>
<style lang="less" scoped>
</style>
